import { Controller } from 'stimulus'
import { Datepicker } from 'vanillajs-datepicker';

export default class extends Controller {
    static targets = ['picker']

    connect() {
        new Datepicker(
            this.pickerTarget,
            {
                buttonClass: 'btn',
                format: 'dd-mm-yyyy'
            }
        )

         this.pickerTarget.addEventListener('changeDate', (event) => {
            const changeEvent = new Event('change', { bubbles: true })
            event.currentTarget.dispatchEvent(changeEvent)
        })
    }
}
